import {IWizard} from "./models";

export var deviceImages = {
    'iPhone': 'images/design-2019/devices/iphone.svg',
    'iPad': 'images/design-2019/devices/ipad.svg',
    'Samsung Phone': 'images/design-2019/devices/samsung-phone.svg',
    'Samsung Tablet': 'images/design-2019/devices/samsung-tablet.svg',
    'Huawei': 'images/design-2019/devices/huawei-phone.svg'
};

export var exampleData : IWizard = {
    questions: [
        {
            name: "Device",
            title: "Please select your device"
        },
        {
            name: "Model",
            title: 'What Model?'
        },
        {
            name: "Color",
            title: 'What Color is it?'
        },
        {
            name: "Capacity",
            title: 'What Capacity is it?'
        },
        {
            name: "Issue",
            title: 'What is the issue?',
            isMultipleChoice: true,
            showSendEmailNote: true
        },
        {
            name: "Details",
            title: "Please enter your details",
            showDetailsForm: true
        },
        {
            name: "Quote",
            title: "",
            showQuote: true
        },
        {
            name: "Address",
            title: 'Please fill in your address',
            showAddressForm: true
        }
    ],
    configurations: [],
    settings: {
        vat: 14,
        labour: 280,
        courier: 200
    }
};

export var oldExampleData : IWizard = {
    questions: [
        {
            name: "Device",
            title: "Please select your device",
            choices: {
                '/': [
                    {name: 'iPhone', image: 'images/wizard/iphone-icon.png'},
                    {name: 'iPad', image: 'images/wizard/ipad-icon.png'},
                    {name: 'Samsung Phone', image: 'images/wizard/samsung-phone-icon.png'},
                    {name: 'Samsung Tablet', image: 'images/wizard/samsung-tablet-icon.png'}
                ]
            }
        },
        {
            name: "Model",
            title: 'What Model?',
            choices: {
                '/iPhone': ['6s Plus', '6s', '6 Plus', '6', '5s', '5c', '5', '4S', '4'],
                '/iPad': ['Mini 3', 'Mini 2', 'Mini', 'Air', '4', '3', '2', '1'],
                '/Samsung Phone': ['S6 Edge', 'S6', 'S5', 'S4 Mini', 'S4', 'S3', 'Note 4', 'Note 3', 'Note 2'],
                '/Samsung Tablet': ['Tab 2', 'Tab 3']
            }
        },
        {
            name: "Color",
            title: 'What Color is it?',
            choices: {
                '/iPhone/6s Plus': ['Gold', 'Space Gray', 'Silver', 'Rose Gold'],
                '/iPhone/6s': ['Gold', 'Space Gray', 'Silver', 'Rose Gold'],
                '/iPhone/6 Plus': ['Gold', 'Space Gray', 'Silver'],
                '/iPhone/6': ['Gold', 'Space Gray', 'Silver'],
                '/iPhone/5s': ['Gold', 'Space Gray', 'Silver'],
                '/iPhone/5c': ['Yellow', 'White', 'Pink', 'Green', 'Blue'],
                '/iPhone/5': ['Black', 'White'],
                '/iPhone/4S': ['Black', 'White'],
                '/iPhone/4': ['Black', 'White'],
                '/iPad/Mini 3': ['Gold', 'Space Gray', 'Silver'],
                '/iPad/*': ['Silver', 'Space Gray'],
                '/*/*': ['Silver', 'White', 'Black', 'Gold', {name: 'Other', showTextbox: true}]
            }
        },
        {
            name: "Issue",
            title: 'What is the issue?',
            isMultipleChoice: true,
            choices: {
                '/*/*/*/*': ['Broken Screen', 'Battery', 'Water Damage', "Won't Turn On", 'Other']
            }
        },
        {
            name: "Details",
            title: "Please enter your details",
            showDetailsForm: true
        },
        {
            name: "Quote",
            title: "The estimated cost of repairing your phone is",
            showQuote: true
        },
        {
            name: "Address",
            title: 'Please fill in your address',
            showAddressForm: true
        }
    ],
    configurations: [],
    settings: {
        vat: 14,
        labour: 280,
        courier: 200
    }
};
